<div class="container">
  <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

  <!-- Breadcrumb -->
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li class="active">
      <span>Cadastros/<b>Habilitação Mastercard Urbanos (Bacen)</b></span>
    </li>
  </ul>

  <!-- Status Header -->
  <div class="status-header">
    <div class="status-info">
      <span class="status-label">Status do processo:</span>
      <span class="status-badge" [ngClass]="{
        'badge-nao-iniciado': status === 'NAO_INICIADO',
        'badge-preenchimento': status === 'EM_PREENCHIMENTO',
        'badge-submetido': status === 'SUBMETIDO',
        'badge-ajuste': status === 'AJUSTE_SOLICITADO',
        'badge-aprovado': status === 'APROVADO'
      }">
        {{ statusLabel }}
      </span>
    </div>
    <div class="status-actions">
      <button mat-stroked-button class="btn-cinza" (click)="consultarStatus()"
        matTooltip="Consultar status atualizado na SWAP" matTooltipPosition="above" type="button">
        <mat-icon>refresh</mat-icon> Consultar Status
      </button>
    </div>
  </div>

  <!-- Alert Banners -->
  <div class="alert-banner alert-sucesso" *ngIf="status === 'APROVADO'">
    <mat-icon>check_circle</mat-icon>
    <div>
      <strong>Habilitação aprovada!</strong>
      <span *ngIf="dataLiberacao"> - Liberado em: {{ dataLiberacao }}</span>
    </div>
  </div>

  <div class="alert-banner alert-erro" *ngIf="status === 'AJUSTE_SOLICITADO'">
    <mat-icon>error_outline</mat-icon>
    <div>
      <strong>Ajustes solicitados pela SWAP.</strong>
      <span *ngIf="mensagemSwap"> {{ mensagemSwap }}</span>
      <span> Corrija os dados e submeta novamente.</span>
    </div>
  </div>

  <div class="alert-banner alert-info" *ngIf="status === 'SUBMETIDO'">
    <mat-icon>hourglass_empty</mat-icon>
    <div>
      <strong>Dados submetidos.</strong>
      <span> Aguardando retorno da SWAP. Use "Consultar Status" para verificar atualizações.</span>
    </div>
  </div>

  <!-- ==================== TABS ==================== -->
  <div class="tabs-container">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="200ms">

      <!-- TAB 1: Sócios -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">people</mat-icon>
          Sócios
          <span class="tab-badge">{{ socios.length }}</span>
        </ng-template>

        <div class="tab-content">
          <!-- Action buttons -->
          <div class="tab-actions" *ngIf="isEditable">
            <button mat-flat-button class="btn-primario" type="button" (click)="cadastrarSocio()">
              <mat-icon>person_add</mat-icon>
              Cadastrar Sócio
            </button>
            <button mat-flat-button class="btn-destaque" type="button" (click)="submeterParaValidacao()"
              [disabled]="socios.length === 0"
              matTooltip="Submeter todos os sócios para validação SWAP/Bacen"
              matTooltipPosition="above">
              <mat-icon>send</mat-icon>
              Submeter para Validação
            </button>
          </div>

          <!-- Tabela -->
          <table mat-table [dataSource]="dataSource" matSort class="w-100">
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
              <td mat-cell *matCellDef="let socio">{{ socio.nome }}</td>
            </ng-container>

            <ng-container matColumnDef="tipoDocumento">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
              <td mat-cell *matCellDef="let socio">{{ socio.tipoDocumento }}</td>
            </ng-container>

            <ng-container matColumnDef="cpfCnpj">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>CPF/CNPJ</th>
              <td mat-cell *matCellDef="let socio">{{ socio.cpfCnpj | cpfCnpj }}</td>
            </ng-container>

            <ng-container matColumnDef="dataNascimento">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Nascimento</th>
              <td mat-cell *matCellDef="let socio">{{ socio.dataNascimento || '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="nomePai">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome do Pai</th>
              <td mat-cell *matCellDef="let socio">{{ socio.nomePai || '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="nomeMae">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome da Mãe</th>
              <td mat-cell *matCellDef="let socio">{{ socio.nomeMae || '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let socio">
                <button mat-icon-button (click)="editarSocio(socio)" matTooltip="Editar sócio" matTooltipPosition="left">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="removerSocio(socio)" matTooltip="Remover sócio" matTooltipPosition="right">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell no-data" [attr.colspan]="columns.length">
                Nenhum sócio cadastrado. Clique em "Cadastrar Sócio" para começar.
              </td>
            </tr>
          </table>

          <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
        </div>
      </mat-tab>

      <!-- TAB 2: Histórico de Validação -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">history</mat-icon>
          Histórico
          <span class="tab-badge">{{ historico.length }}</span>
        </ng-template>

        <div class="tab-content">
          <div class="historico-timeline" *ngIf="historico.length > 0; else semHistorico">
            <div class="timeline-item" *ngFor="let item of historico; let last = last">
              <div class="timeline-marker" [ngClass]="{
                'marker-info': item.tipo === 'INFO',
                'marker-sucesso': item.tipo === 'APROVADO',
                'marker-erro': item.tipo === 'REJEITADO' || item.tipo === 'AJUSTE',
                'marker-submissao': item.tipo === 'SUBMISSAO'
              }"></div>
              <div class="timeline-content" [class.timeline-last]="last">
                <div class="timeline-header">
                  <span class="timeline-data">{{ item.dataFormatada }}</span>
                  <span class="timeline-tipo" [ngClass]="{
                    'tipo-info': item.tipo === 'INFO',
                    'tipo-sucesso': item.tipo === 'APROVADO',
                    'tipo-erro': item.tipo === 'REJEITADO' || item.tipo === 'AJUSTE',
                    'tipo-submissao': item.tipo === 'SUBMISSAO'
                  }">{{ item.tipo }}</span>
                </div>
                <div class="timeline-descricao">{{ item.descricao }}</div>
                <div class="timeline-usuario" *ngIf="item.usuario">
                  <mat-icon>person_outline</mat-icon>
                  <span>{{ item.usuario }}</span>
                </div>
              </div>
            </div>
          </div>

          <ng-template #semHistorico>
            <div class="empty-state">
              <mat-icon>schedule</mat-icon>
              <span>Nenhum registro no histórico ainda.</span>
            </div>
          </ng-template>
        </div>
      </mat-tab>

      <!-- TAB 3: Log de Auditoria -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">assignment</mat-icon>
          Log de Auditoria
          <span class="tab-badge">{{ logs.length }}</span>
        </ng-template>

        <div class="tab-content">
          <div class="log-lista" *ngIf="logs.length > 0; else semLogs">
            <div class="log-item" *ngFor="let log of logs">
              <div class="log-header">
                <span class="log-data">{{ log.dataHora }}</span>
                <span class="log-acao" [ngClass]="{
                  'acao-acesso': log.acao === 'ACESSO',
                  'acao-inclusao': log.acao === 'INCLUSAO',
                  'acao-alteracao': log.acao === 'ALTERACAO',
                  'acao-exclusao': log.acao === 'EXCLUSAO',
                  'acao-submissao': log.acao === 'SUBMISSAO',
                  'acao-status': log.acao === 'STATUS'
                }">{{ log.acao }}</span>
              </div>
              <div class="log-detalhe">{{ log.detalhe }}</div>
              <div class="log-usuario">
                <mat-icon>person_outline</mat-icon>
                <span>{{ log.usuario }}</span>
              </div>
            </div>
          </div>

          <ng-template #semLogs>
            <div class="empty-state">
              <mat-icon>assignment</mat-icon>
              <span>Nenhum log registrado.</span>
            </div>
          </ng-template>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>

  <!-- Scroll to top -->
  <div class="row mt-4 mb-3">
    <div class="col text-end">
      <button mat-stroked-button class="btn-cinza" (click)="scrollToTopAnimated()"
        matTooltip="Ir para o topo da página" matTooltipPosition="above" type="button">
        <mat-icon>vertical_align_top</mat-icon>
        Ir para o topo
      </button>
    </div>
  </div>
</div>
